import { render } from "./AppWidgetSocial.html?vue&type=template&id=051b61f1"
import script from "./AppWidgetSocial.js?vue&type=script&lang=js"
export * from "./AppWidgetSocial.js?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__